import React from 'react';
import './RouteDialog.css';

const RouteDialog = ({ 
  isOpen, 
  pendingRoute, 
  onAdd, 
  onCancel 
}) => {
  if (!isOpen || !pendingRoute) return null;

  return (
    <div className="route-dialog-overlay" onClick={onCancel}>
      <div className="route-dialog" onClick={e => e.stopPropagation()}>
        <button className="route-dialog-close" onClick={onCancel}>
          ×
        </button>
        <h3>Add Route to Trip Plan</h3>
        <p>Would you like to add this route as a route event to your trip plan?</p>
        <div className="route-dialog-details">
          <p><strong>Route Name:</strong> {pendingRoute.eventsWithLocations[0].description} → {pendingRoute.eventsWithLocations[pendingRoute.eventsWithLocations.length - 1].description}</p>
          <p><strong>Route Details:</strong> {pendingRoute.eventsWithLocations.map(event => event.description).join(' → ')}</p>
          <p><strong>Will be added to:</strong> Day {pendingRoute.eventsWithLocations[0].dayIdx + 1}</p>
        </div>
        <div className="route-dialog-actions">
          <button className="route-dialog-btn route-dialog-btn-add" onClick={onAdd}>
            Add to trip plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default RouteDialog;
